/**
 * Sets a placeholder on Kendo filter input components if ariaLabel is 'Filter'.
 * @param {Object} props - The original props of the component.
 * @param {string} placeholder - The placeholder text to use.
 * @returns {Object} Modified props with a placeholder for filter inputs.
 */
const setPlaceholderText = (props, placeholder = 'Search...') => {
    if (props.ariaLabel === 'Filter') {
        return { ...props, placeholder };
    }
    return props;
};

// Aliases for Kendo context usage (in case of customization per type in the future)
const numericTextBoxPropsCallback = (props) => setPlaceholderText(props);
const inputPropsCallback = (props) => setPlaceholderText(props);
const datePickerPropsCallback = (props) => setPlaceholderText(props);

export {
    numericTextBoxPropsCallback,
    inputPropsCallback,
    datePickerPropsCallback,
    setPlaceholderText
};